import { motion } from "framer-motion";
import { Clock } from "lucide-react";

const videos = [
  {
    id: "96qsdqEtj7E",
    title: "Piątkowski Detroit",
    type: "youtube",
  },
  {
    id: "3byrcvdiBcA",
    title: "Pierwsze Miejsce",
    type: "youtube",
  },
  {
    id: "wFhukoymIQE",
    title: "ADRENALINA",
    type: "youtube",
  },
];

export default function VideoSection() {
  return (
    <section
      id="videos"
      data-testid="video-section"
      className="relative py-24 md:py-32 bg-[#192D48]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tighter mb-2"
            data-testid="video-section-title"
          >
            Klipy
          </h2>
          <div className="w-16 h-[2px] bg-[#EB0023] mb-10" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {videos.map((video, idx) => (
            <motion.div
              key={video.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: idx * 0.15 }}
            >
              {video.type === "youtube" ? (
                <div className="video-glow">
                  <div className="aspect-video bg-[#192D48]/30 border border-[#32558B]/20 overflow-hidden">
                    <iframe
                      data-testid={`youtube-embed-${video.id}`}
                      title={video.title}
                      src={`https://www.youtube.com/embed/${video.id}?rel=0&modestbranding=1`}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                      className="w-full h-full"
                    />
                  </div>
                </div>
              ) : (
                <div
                  data-testid="video-placeholder-adrenalina"
                  className="aspect-video bg-[#192D48]/30 border border-[#32558B]/20 flex flex-col items-center justify-center relative overflow-hidden group cursor-pointer"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-[#EB0023]/5 to-[#192D48]/10 group-hover:from-[#EB0023]/10 transition-all duration-500" />
                  <Clock className="w-10 h-10 text-[#EB0023]/60 mb-3 relative z-10" />
                  <span className="font-['Oswald'] text-xl uppercase tracking-wider text-[#A0B0C4] relative z-10">
                    Wkrótce
                  </span>
                </div>
              )}
              <p className="mt-3 font-['Oswald'] text-lg uppercase tracking-wider text-[#A0B0C4]">
                {video.title}
                {video.type === "coming-soon" && (
                  <span className="ml-2 text-xs text-[#EB0023] font-['Manrope'] tracking-normal normal-case">
                    — premiera wkrótce
                  </span>
                )}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
